/** Legal copy aligned with WasOK `docs/PRIVACY_POLICY.md` / `docs/TERMS_OF_SERVICE.md`. */
export const legalMessagesDa = {
  privacy: {
    pageTitle: "Privatlivspolitik",
    lastUpdated: "Senest opdateret: 1. juni 2026",
    introduction: {
      title: "Introduktion",
      body: "WasOK er en lokal-først shoppinghjælper-app designet til at hjælpe brugere med at huske produkter, de tidligere har købt, bedømt eller anmeldt.\n\nDenne privatlivspolitik forklarer, hvilke oplysninger der behandles, når du bruger appen, hvordan data gemmes, og hvordan visse tredjepartstjenester kan fungere.",
    },
    dataStored: {
      title: "Data gemt af appen",
      body: "WasOK gemmer følgende oplysninger lokalt på din enhed:\n\n• scannede produktstregkoder\n• produktnavne og detaljer indtastet af brugeren\n• bedømmelser og kommentarer\n• indkøbslister\n• produktkategorier\n• priser og butiksoplysninger\n• produkt- og butiksfotos\n\nDine produktdata og fotos uploades ikke til WasOK-servere.",
    },
    permissions: {
      title: "Anvendte tilladelser",
      camera: {
        title: "Kamera",
        body: "Kameraadgang bruges til:\n\n• scanning af stregkoder\n• at tage produktfotos",
      },
      photos: {
        title: "Fotos og medier",
        body: "Adgang til fotos eller galleri bruges kun, når:\n\n• du vedhæfter billeder til produkter\n• du gendanner sikkerhedskopier, der indeholder fotos",
      },
      files: {
        title: "Fil- og lageradgang",
        body: "Filadgang kan bruges til:\n\n• eksport af sikkerhedskopifiler\n• import af sikkerhedskopier valgt af brugeren\n• deling af indkøbslister eller sikkerhedskopier",
      },
    },
    backup: {
      title: "Sikkerhedskopi og eksport",
      body: "WasOK giver brugere mulighed for at oprette sikkerhedskopifiler med appdata og valgfrie fotos.\n\nSikkerhedskopifiler oprettes lokalt på din enhed og kan gemmes eller deles via tjenester valgt af brugeren, såsom:\n\n• Google Drive\n• Dropbox\n• iCloud Drive\n• lokal lagerplads på enheden\n\nWasOK uploader ikke sikkerhedskopier til egne servere.",
      onlineProductLookup: {
        title: "Online produktsøgning",
        body: "Når du aktiverer online stregkodesøgning under Indstillinger, kan WasOK sende kun det scannede stregkodenummer til offentlige produktdatabaser (såsom Open Food Facts) for at foreslå et produktnavn og et mærke. WasOK uploader ikke dine bedømmelser, kommentarer, fotos, indkøbslister, kategorier, butiksoplysninger eller sikkerhedskopidata til denne funktion. Du kan til enhver tid deaktivere dette under Indstillinger.",
      },
    },
    advertising: {
      title: "Reklamer og tredjepartstjenester",
      intro:
        "WasOK bruger udvalgte tredjepartstjenester til at levere visse funktioner.",
      admob: {
        title: "Google AdMob",
        body: "Google AdMob bruges til at vise reklamer i appen.\n\nGoogle og dets partnere kan behandle oplysninger såsom:\n\n• reklameidentifikatorer\n• enhedsoplysninger\n• IP-adresse\n• diagnostik- og brugsoplysninger\n\nBrugere i visse regioner kan blive bedt om samtykke, før personlige annoncer vises.",
      },
      crashlytics: {
        title: "Firebase Crashlytics",
        body: "WasOK bruger Firebase Crashlytics til at identificere nedbrud og forbedre appens stabilitet.\n\nNedbrudsrapporter kan indeholde tekniske oplysninger såsom:\n\n• enhedsmodel\n• version af operativsystem\n• appversion\n• nedbrudsdiagnostik\n\nNedbrudsrapporter indeholder ikke med vilje dine produktbedømmelser, noter, indkøbslister eller fotos.",
      },
      externalProductDatabases: {
        title: "Eksterne produktdatabaser",
        body: "Stregkodesøgningsfunktionen kan bruge eksterne produktdatabaser til at hente produktinformation.\n\nFor mere information bedes du gennemgå privatlivspolitikkerne for de respektive udbydere.",
      },
    },
    dataSecurity: {
      title: "Datasikkerhed",
      body: "WasOK gemmer appdata lokalt på din enhed ved hjælp af lagringsmekanismer, der leveres af operativsystemet.\n\nSelvom der træffes rimelige foranstaltninger for at beskytte lokale appdata, er ingen metode til elektronisk lagring helt sikker.\n\nBrugere er ansvarlige for at vedligeholde sikkerhedskopier af vigtige data, hvis det ønskes.",
    },
    children: {
      title: "Børns privatliv",
      body: "WasOK er ikke rettet mod børn under 13 år.",
    },
    notifications: {
      title: "Notifikationer",
      body: "WasOK kan valgfrit oprette lokale notifikationer på din enhed for at minde dig om at bedømme produkter efter køb.\n\nDisse notifikationer genereres og planlægges lokalt på din enhed og kræver ikke en konto eller en fjernserver.\n\nDu kan til enhver tid deaktivere notifikationer via dine enhedsindstillinger eller i appen, hvis det understøttes.",
    },
    yourControl: {
      title: "Din kontrol over data",
      body: "Du kan:\n\n• redigere eller slette gemte produkter når som helst\n• rydde appdata fra din enhed\n• afinstallere appen\n• eksportere sikkerhedskopier af dine data",
    },
    changes: {
      title: "Ændringer af denne politik",
      body: "Denne privatlivspolitik kan opdateres fra tid til anden.\n\nÆndringer træder i kraft, når den opdaterede version offentliggøres.",
    },
    contact: {
      title: "Kontakt",
      body: "Hvis du har spørgsmål til denne privatlivspolitik, bedes du kontakte:\n\nsupport@wasok.app",
    },
  },
  terms: {
    pageTitle: "Servicevilkår",
    lastUpdated: "Senest opdateret: 1. juni 2026",
    acceptance: {
      title: "Accept af vilkår",
      body: "Ved at downloade, installere eller bruge WasOK accepterer du disse servicevilkår.\n\nHvis du ikke er enig i disse vilkår, bør du ikke bruge appen.",
    },
    license: {
      title: "Licens",
      body: "WasOK giver dig en begrænset, ikke-eksklusiv, ikke-overdragelig, tilbagekaldelig licens til at bruge appen i overensstemmelse med disse vilkår.",
    },
    acceptableUse: {
      title: "Acceptabel brug",
      body: "Du accepterer ikke at:\n\n• misbruge appen\n• forstyrre appens drift\n• forsøge at reverse-engineere eller ændre appen\n• bruge appen i strid med gældende love eller regler",
    },
    localData: {
      title: "Lokale data og sikkerhedskopier",
      body: "WasOK gemmer brugerdata lokalt på enheden.\n\nBrugere er ansvarlige for at vedligeholde sikkerhedskopier af vigtige data, hvis det ønskes.\n\nSelvom sikkerhedskopi- og gendannelsesfunktionalitet kan være tilgængelig, garanterer WasOK ikke mod tab, korruption eller fejl af gemte data.",
    },
    advertisements: {
      title: "Reklamer",
      body: "Appen kan vise reklamer leveret af tredjepartsannoncører, herunder Google AdMob.",
    },
    noWarranty: {
      title: "Ingen garanti",
      body: "WasOK leveres \"som den er\" og \"som tilgængelig\" uden garantier af nogen art, udtrykkelige eller underforståede.\n\nVi garanterer ikke, at:\n\n• appen altid er tilgængelig\n• appen er fejlfri\n• datatab aldrig indtræffer\n• alle funktioner fungerer uafbrudt på alle enheder",
    },
    limitationLiability: {
      title: "Ansvarsbegrænsning",
      body: "I det omfang loven tillader det, er WasOK og dens udviklere ikke ansvarlige for:\n\n• datatab\n• tab af fortjeneste\n• enhedsproblemer\n• indirekte eller følgeskader\n• afbrydelser som følge af brug eller manglende mulighed for at bruge appen",
    },
    thirdParty: {
      title: "Tredjepartstjenester",
      body: "Visse funktioner eller indhold kan afhænge af tredjepartstjenester, herunder reklameudbydere og eksterne lager-/delingstjenester valgt af brugeren.\n\nWasOK er ikke ansvarlig for tredjepartstjenester eller deres politikker.",
    },
    productInformation: {
      title: "Produktinformation",
      body: "Visse produktdetaljer kan hentes fra tredjeparts stregkodesøgningstjenester.\n\nWasOK garanterer ikke nøjagtigheden, fuldstændigheden, tilgængeligheden eller egnetheden af oplysninger fra eksterne datakilder.\n\nBrugere bør selv verificere produktinformation, når det er nødvendigt.",
    },
    changesApp: {
      title: "Ændringer af appen",
      body: "WasOK kan ændres, opdateres, midlertidigt standses eller indstilles når som helst uden forudgående varsel.",
    },
    changesTerms: {
      title: "Ændringer af disse vilkår",
      body: "Disse vilkår kan opdateres periodisk.\n\nFortsættelse af brugen af appen, efter at opdateringer træder i kraft, udgør accept af de reviderede vilkår.",
    },
    contact: {
      title: "Kontakt",
      body: "Ved spørgsmål til disse vilkår, kontakt:\n\nsupport@wasok.app",
    },
  },
};
